<template>
  <nav class="sidebar d-flex flex-column" id="sidebar">
    <ul class="admin-nav" role="tablist">
      <li class="admin-nav-item" v-for="country in fit20.countries">
        <div class="country" @click="toggleCountry(country)">
          <span class=" item">{{ country.name }}</span>
          <span :class="'flag-icon ' + country.icon"></span>
        </div>
        <div :class="['lang', { 'selected': 'studios' == fit20.selectedTabHref }]" v-if="activeCountry === country.name"
          @click="toggleLocatorLang()">
          Studios/Locator data
        </div>
        <div v-if="activeLocatorLang">
          <div class="act-land" v-if="activeCountry === country.name">
            <div v-for="lang, index in Object.keys(country.sites)" :key="lang" :class="[{
              'selected-lang': activeStudios == lang &&
                selectedCountry == country.name
            }, { hovered: hoveredIndex === index }]" @click.stop.prevent="toggleStudio(lang, country.name)"
              @mouseover="hoveredIndex = index" @mouseleave="hoveredIndex = null">
              {{ lang }}

            </div>
          </div>
        </div>
        <div v-for="lang, index in Object.keys(country.sites)" :key="lang + index">
          <div v-if="activeStudios == lang && selectedCountry == country.name">
            <div :class="['site', { 'selected': 'studios_country-' + lang == fit20.selectedTabHref }]"
              @click.stop.prevent="getStudios('studios_country-' + lang, country.sites[lang][0].code)">
              Country
            </div>
            <div :class="['site', { 'selected': 'studios_franchise-' + lang == fit20.selectedTabHref }]"
              @click.stop.prevent="getStudios('studios_franchise-' + lang, country.sites[lang][2].code)">
              Franchise
            </div>
          </div>
        </div>
        <div class="lang" v-if="activeCountry === country.name" @click="toggleBlocksLang()">
          Blocks Content

        </div>

        <div v-if="activeBlocksLang">
          <div class="act-lang" v-if="activeCountry === country.name">
            <div v-for="lang, index in Object.keys(country.sites)" :key="lang"
              @click.stop.prevent="toggleLang(lang, country.name)" :class="[{
                'selected-lang': activeLang == lang &&
                  selectedCountry == country.name
              }, { hovered: hover2 === index }]" @mouseover="hover2 = index" @mouseleave="hover2 = null">
              {{ lang }}

            </div>
          </div>
        </div>
        <div v-for="lang, index in Object.keys(country.sites)" :key="country.name + lang + index">
          <div v-if="activeLang === lang && selectedCountry == country.name">
            <div :class="['site', { 'selected': site.name == fit20.selectedTabHref }]"
              v-for="site in country.sites[lang]" :key="site.name"
              @click.stop.prevent="selectTab(site.name, site.code)">
              {{ site.name }}
            </div>
          </div>
        </div>
        <div class="lang" v-if="activeCountry === country.name && Object.keys(country.sites).length > 1"
          @click="getURLS(country.name)">
          URLS

        </div>
        <div class='lang'
          v-if="fit20.user.role == 'super_admin' && activeCountry === country.name && fit20.user.email == 'mohammaddarwesh@fit20.com'"
          @click="showAddLanguage(country)">
          <span class=" item">Add language</span>
          <span class="fa fa-plus"></span>
        </div>
      </li>
      <li class="admin-nav-item"
        v-if="fit20.user.role == 'super_admin' && fit20.user.email == 'mohammaddarwesh@fit20.com'">
        <div class="country" @click="showAddCountry()">
          <span class=" item">Add country</span>
          <span class="fa fa-plus"></span>
        </div>
      </li>
    </ul>
    <!-- start add country popup  -->
    <div class="popup-overlay" v-if="country">
      <div class="edit-member">
        <div class='popup-title flex'>
          <span>Add country</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="showAddCountry(true)" />
        </div>
        <div class="flex edit-member-body">
          <form class="session-form-container" id="admin_studio_info">
            <div class=" edit-member-1sec">
              <div class="field-sec">
                <label>Name*:</label>
                <input type="text" class="form-control" v-model="country.name" />
              </div>
              <div class="field-sec">
                <label>Country code*(As in Zoho site):</label>
                <input type="text" class="form-control" v-model="country.code" />
              </div>
              <div class="field-sec">
                <label>Main language*:</label>
                <select id="" class="" v-model="country.lang">
                  <option v-for="lang in fit20.languages" :value=lang.code>{{ lang.name }}</option>
                </select>
              </div>
              <div class="field-sec">
                <label>The name of the studios folder*(As in Zoho site):</label>
                <input type="text" class="form-control" v-model="country.studios" />
              </div>
              <div class="field-sec">
                <label>The name of the franchise folder*(As in Zoho site):</label>
                <input type="text" class="form-control" v-model="country.franchise" />
              </div>
            </div>
          </form>
        </div>
        <div>
          <div class="fake-div"></div>
          <div class="btn-container">
            <span :class="'fit20-btn ' + (isChanged ? 'save-btn-active' : 'save-btn-disable')" @click="addCountry">
              Save
            </span>
          </div>
        </div>
        <br>
      </div>
    </div>
    <!-- end add country popup  -->
    <!-- start add lang popup  -->
    <div class="popup-overlay" v-if="language">
      <div class="edit-member">
        <div class='popup-title flex'>
          <span>Add language</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="showAddLanguage(false)" />
        </div>
        <div class="flex edit-member-body">
          <form class="session-form-container" id="admin_studio_info">
            <div class=" edit-member-1sec">
              <div class="field-sec">
                <label>Country name:</label>
                <input type="text" class="form-control" v-model="language.countryName" disabled />
              </div>
              <div class="field-sec">
                <label>Country code*(As in Zoho site):</label>
                <input type="text" class="form-control" v-model="language.countryCode" disabled />
              </div>
              <div class="field-sec">
                <label>language*(The language folder in Zoho must match the language code):</label>
                <select id="" class="" v-model="language.lang">
                  <option v-for="lang in fit20.languages" :value=lang.code>{{ lang.name + ' code: ' + lang.code }}
                  </option>
                </select>
              </div>
              <div class="field-sec">
                <label>The name of the studios folder*(As in Zoho site):</label>
                <input type="text" class="form-control" v-model="language.studios" />
              </div>
              <div class="field-sec">
                <label>The name of the franchise folder*(As in Zoho site):</label>
                <input type="text" class="form-control" v-model="language.franchise" />
              </div>
            </div>
          </form>
        </div>
        <div>
          <div class="fake-div"></div>
          <div class="btn-container">
            <span :class="'fit20-btn ' + (isChanged ? 'save-btn-active' : 'save-btn-disable')" @click="addLanguage">
              Save
            </span>
          </div>
        </div>
        <br>
      </div>
    </div>
    <!-- end add lang popup  -->
  </nav>
</template>


<script>
export default {
  name: 'MainMenu',
  props: ["user", "selectTab", "admin_fit20", "fit20"],
  data() {
    return {
      activeBlocksLang: false,
      activeLocatorLang: false,
      activeCountry: null,
      activeLang: null,
      activeStudios: false,
      country: null,
      language: null,
      isChanged: false,
      // hover: false,
      hover2: null,
      selectedCountry: false,
      hoveredIndex: null,
      // urls: {},
    };
  },
  methods: {
    async getURLS(countryName) {
      this.fit20.isLoaded = false;
      try {
        const getAllUrls = await fetch(this.fit20.baseUrl + "/api/block/Routes?code=" + countryName);
        let data = await getAllUrls.json();
        console.log(data);
        if (data && data.msg) {
        } else {
          this.fit20.urls = data;
          if (typeof this.fit20.urls.routes === 'string') {
            this.fit20.urls.routes = JSON.parse(this.fit20.urls.routes);
          } else
            this.fit20.urls.routes = this.fit20.urls.routes;
        }
        this.fit20.isLoaded = true;
      } catch (err) {
        console.log(err);
        this.fit20.isLoaded = true;
        alert(err);
      }
      this.selectTab("URLS", countryName);
    },
    showAddLanguage(country) {
      let mainLang;

      if (country) {
        Object.keys(country.sites).forEach(site => {
          if (!country.sites[site][0].extraLang) {
            mainLang = country.sites[site][0].code;
          }
        })
        this.language = {
          countryName: country.name,
          countryCode: mainLang,
          lang: '',
          studios: '',
          franchise: '',
        }
      } else {
        this.language = null;
      }
    },
    async addLanguage() {
      const allFieldsFilled = Object.values(this.language).every((value) => value != '');
      if (!allFieldsFilled) {
        alert('Please fill in all fields!');
      } else {
        // Do something if all fields are filled
        console.log('All fields are filled!');
        let countryToAddLang = this.fit20.countries.find(country => country.name == this.language.countryName);
        countryToAddLang.sites[this.language.lang] = [
          { code: this.language.countryCode + this.language.lang + '/', name: 'country', extraLang: true },
          { code: this.language.countryCode + this.language.lang + '/' + this.language.studios + '/', name: 'studio' },
          { code: this.language.countryCode + this.language.lang + '/' + this.language.franchise + '/', name: 'franchise' },
        ]
        this.fit20.countries = JSON.parse(JSON.stringify(this.fit20.countries));
        await fetch(this.fit20.baseUrl + "/api/countries/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(countryToAddLang),
        });
        console.log(this.fit20.countries);
        this.language = null;
      }
    },
    showAddCountry(close) {
      if (!close) {
        this.country = {
          name: '',
          code: '',
          lang: '',
          studios: '',
          franchise: '',
        }
      } else {
        this.country = null;
      }

    },
    async addCountry() {
      const allFieldsFilled = Object.values(this.country).every((value) => value != '');
      if (!allFieldsFilled) {
        alert('Please fill in all fields!');
      } else {
        try {
          // Do something if all fields are filled
          console.log('All fields are filled!');
          let data = {
            name: this.country.name,
            icon: 'flag-icon-' + this.country.code,
            sites: {
              [this.country.lang]: [
                { code: '/' + this.country.code + '/', name: 'country' },
                { code: '/' + this.country.code + '/' + this.country.studios + '/', name: 'studio' },
                { code: '/' + this.country.code + '/' + this.country.franchise + '/', name: 'franchise' },
              ],
            },
          };

          await fetch(this.fit20.baseUrl + "/api/countries/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
          });
          this.fit20.countries.push(data);
          console.log(data);
        } catch (err) {
          window.alert('something went wrong!')
        }
        this.country = null;
      }
    },
    toggleCountry(country) {
      this.selectTab('');
      this.toggleBlocksLang(true);
      this.toggleLocatorLang(true);
      this.activeCountry = this.activeCountry === country.name ? null : country.name;
      this.fit20.activeCountry = this.activeCountry;
      this.activeLang = null;
      this.activeStudios = false;
      this.selectedCountry = null;
    },
    toggleLang(lang, countryName) {

      this.activeLang = this.activeLang === lang ? null : lang;
      this.selectedCountry = this.activeLang || this.activeStudios ? countryName : null;

      if (!this.activeLang && !this.activeStudios || ["country", "franchise", "studio"].includes(this.fit20.selectedTabHref)) {
        this.selectTab('');
      }
    },
    toggleStudio(lang, countryName) {

      this.activeStudios = this.activeStudios === lang ? null : lang;
      this.selectedCountry = this.activeStudios || this.activeLang ? countryName : null;
      if (!this.selectedCountry) {
        this.activeLang = null;
        this.activeStudios = false;
      }

      if (!this.activeStudios && !this.activeLang || this.fit20.selectedTabHref.includes('studios_')) {
        this.selectTab('');
      }
    },
    toggleLocatorLang(close) {
      if (close) {
        this.activeLocatorLang = false;
        this.selectTab('');
      } else {
        this.activeLocatorLang = !this.activeLocatorLang;
        // this.selectedCountry = null;
        if (this.activeStudios && this.fit20.selectedTabHref.includes('studios_')) {
          this.selectTab('');
        }
        this.activeStudios = false;
      }

    },
    toggleBlocksLang(close) {
      if (close) {
        this.activeBlocksLang = false;
        this.selectTab('');
      } else {
        this.activeBlocksLang = !this.activeBlocksLang;
        if (!this.activeBlocksLang) {
          // this.selectedCountry = null;
          if (this.activeLang && ["country", "franchise", "studio"].includes(this.fit20.selectedTabHref)) {
            this.selectTab('');
          }
          this.activeLang = null;
        }
      }
    },
    async getStudios(name, code) {
      this.fit20.isLoaded = false;
      try {
        const getAllStudios = await fetch(this.fit20.baseUrl + "/api/studios?code=" + code);
        let data = await getAllStudios.json();
        if (data && data.msg) {
          this.fit20.studios = [];
        } else {
          this.fit20.studios = data.features
        }
        this.fit20.isLoaded = true;
      } catch (err) {
        console.log(err);
        this.fit20.isLoaded = true;
        alert(err);
      }
      this.selectTab(name, code);

    }
  },
};
</script>

<style scoped>
.selected {
  background-color: var(--fit20-blue);
  color: white;
  border-radius: 5px;
  text-align: center;
  transition: all .8s;

}

.selected-lang {
  background-color: var(--fit20-pink);
  color: white;
  border-radius: 5px;
  text-align: center;
  transition: all .8s;

}

.admin-nav {
  width: 100%;
  padding-top: 20px;
}

.admin-nav li {
  width: 100%;
  padding: 5px 15px;
}

.admin-nav li .country {
  padding: 5px 15px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  border: solid 1px #009EFB;
  border-radius: 10px;
  z-index: 999;
  cursor: pointer;
}

.admin-nav li .country:hover {
  background-color: var(--fit20-light-blue);
}

.admin-nav li .lang {
  border-radius: 5px;
  margin-left: 15px;
  cursor: pointer;
  padding-left: 3px;
}



.admin-nav li .lang:hover {
  background-color: var(--fit20-light-blue);
}

.admin-nav li .act-land>div {
  margin-left: 25px;
  cursor: pointer;
  padding-left: 3px;
  border-radius: 5px;
}

.admin-nav li .act-land>div.hovered {
  background-color: var(--fit20-light-blue) !important;
}

.admin-nav li .act-lang>div {
  margin-left: 25px;
  cursor: pointer;
  padding-left: 3px;
  border-radius: 5px;
}

.admin-nav li .act-lang>div.hovered {
  background-color: var(--fit20-light-blue) !important;
}

/* .admin-nav li .lang * {
  pointer-events: none;
} */

.admin-nav li .site {
  margin-left: 35px;
  border-radius: 5px;
  cursor: pointer;
  padding-left: 3px;
}

.admin-nav li .site:hover {
  background-color: var(--fit20-light-blue) !important;
}

.edit-member {
  background-color: white;
  border-radius: 10px;
  width: 50%;
}

.edit-member-body {
  margin-top: 5px;
  padding-bottom: 10px;
}

.edit-member-body>form {
  width: 100%;
  padding-left: 10px;
}

.edit-member-1sec>.field-sec {
  width: 100%;
}

.field-sec {
  margin-top: 15px;
}

.field-sec.flex>label {
  padding: 0px 0px 0px 10px;
  /* margin-left: 10px; */
}

.member-info.flex {
  flex-wrap: nowrap;
}

.session-form-container input,
.session-form-container select,
.session-form-container textarea {
  width: 90%;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.session-form-container input,
.session-form-container select {
  height: 30px;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.field-sec.flex>label {
  width: 48%;
}

.field-sec.flex>input {
  width: fit-content;
}

.session-studio-container input.height {
  width: 60px !important;
  text-align: center;
}

.session-studio-container .fake-div {
  height: 88%;
}

.session-studio-container .close-popup {
  width: 30px;
  padding: 5px;
}
</style>
